import React from 'react'
import styled from '@emotion/styled'
import { array, object, string } from 'prop-types'
// import components
import { Sections } from './Sections'
import { EditorialUpdatesSection } from '@jelly/components'
import { LeftRail } from '@jelly/templates'

// styled components via emotion
const ContentBodyWrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin: auto;

	p {
		color: ${({ theme }) => theme.colors.darkGrey};
	}

	${({ theme }) => theme.MQ.M} {
		margin: 0 auto 50px auto;
		width: 95%;
	}

	${({ theme }) => theme.MQ.XL} {
		${({ theme }) => theme.maxWidth.L};
	}
`
const ImageCreditWrapper = styled.div`
	padding: 0.5rem 0.25rem;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		padding: 0.5rem 0.25rem 0;
	}
`
const ImageCredit = styled.div`
	font-size: 9px;
	text-align: right;

	${({ theme }) => theme.MQ.M} {
		font-size: 12px;
	}
`
const SectionsContainer = styled.div`
	display: block;
	width: 100%;
	${({ theme }) => theme.MQ.L} {
		max-width: calc(98% - 200px);
	}
`
const StreamText = styled.div`
	color: ${({ theme }) => theme.colors.navy};
	display: block;
	font-size: 18px;
	margin: 45px auto 16px auto;
	width: 90%;

	${({ theme }) => theme.MQ.M} {
		display: none;
	}
`

ContentBody.propTypes = {
	displayModified: string.isRequired,
	displayModifiedText: string.isRequired,
	sections: array.isRequired,
	slug: string.isRequired,
	streamText: string,
	subtitle: string.isRequired,
	tocElements: array,
	author: object,
}
/**
 * This is the ContentBody that strings together the Left Rail and Sections
 *
 * @param {Object} props.author :: data for the author of the content
 * @param {String} props.displayModified :: date of last updated from CCM
 * @param {String} props.displayModifiedText :: description of editorial update from CCM
 * @param {Array} props.sections :: list of all the sections in order, set in CCM
 * @param {Object} props.slug :: Slug for the category
 * @param {String} props.streamText :: text describing the category page
 * @param {String} props.subtitle :: name of category
 * @param {Object} props.thumbnail :: data for the hero banner
 * @param {Array} props.tocElements :: list of table of contents elements
 */
export function ContentBody({
	author,
	categoryWidgetId,
	docType,
	displayModified,
	displayModifiedText,
	sections,
	slug,
	streamText,
	subtitle,
	thumbnail,
	tocElements,
}) {
	const { caption } = thumbnail
	return (
		<>
			<ContentBodyWrapper id="top-of-toc">
				<LeftRail docType={docType} tocElements={tocElements} />
				<SectionsContainer>
					<StreamText>{streamText}</StreamText>
					{displayModified && displayModifiedText && (
						<EditorialUpdatesSection
							lastModified={displayModified}
							lastModifiedText={displayModifiedText}
						/>
					)}
					<Sections {...{ sections, slug, subtitle, author, categoryWidgetId }} />
					{caption && (
						<ImageCreditWrapper>
							<ImageCredit>Image Credit: {caption}</ImageCredit>
						</ImageCreditWrapper>
					)}
				</SectionsContainer>
			</ContentBodyWrapper>
		</>
	)
}
